// "/" — redirect-only route. If signed in: go to /app. Else: /login.
// While the session probe is in-flight we render a tiny loader so users
// don't see a white flash.
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useSession } from "../lib/session";
import { Logo } from "../components/Logo";

function Index() {
  const s = useSession();
  if (s.state === "loading") {
    return (
      <main className="min-h-full grid place-items-center px-4">
        <div className="opacity-60"><Logo size="md" /></div>
      </main>
    );
  }
  return <Navigate to={s.state === "signed" ? "/app" : "/login"} replace />;
}

export const Route = createFileRoute("/")({
  component: Index,
});
